import * as Yup from 'yup';
import { ServiceType } from '../entities';
import { Days } from '../utils/time';
import { ReservationScope } from '../entities/reservation-scope.type';

// BASIC DATA STEP
export interface ServiceBasicData {
  label: string;
  type: ServiceType;
  price?: string | null;
  isEnabled?: boolean;
}

type ServiceBasicDataFormShape = {
  [key in keyof ServiceBasicData]?: any;
};

export const basicDataSchema = Yup.object().shape<ServiceBasicDataFormShape>({
  label: Yup.string().required('Digite um nome').min(1, 'Digite um nome'),
  type: Yup.string().required('Selecione o ambiente'),
});

// CONFIGURATIONS STEP
export interface ServiceConfigurationsData {
  maxSimultaneosReservations: string;
  maxReservationsByUnit: string;
  maxReservationsByDweller: string;
  reservationDuration: string;
  disableSequentialReservations: boolean;
  enableExclusiveReservations: boolean;
  reservationScope: ReservationScope;
}

type ServiceConfigurationsDataFormShape = {
  [key in keyof ServiceConfigurationsData]?: any;
};

export const configurationsDataSchema = Yup.object().shape<ServiceConfigurationsDataFormShape>({
  reservationDuration: Yup.mixed().required('Selecione a duração'),
  maxReservationsByUnit: Yup.string(),
  maxReservationsByDweller: Yup.string(),
  reservationScope: Yup.string().required('Selecione o tipo de reserva'),
  maxSimultaneosReservations: Yup.string(),
  disableSequentialReservations: Yup.boolean(),
  enableExclusiveReservations: Yup.boolean(),
});

// SCHEDULE STEP
export interface ServiceScheduleData {
  startAt: string;
  endAt: string;
  days: Days[];
}

type ServiceScheduleDataFormShape = {
  [key in keyof ServiceScheduleData]?: any;
};

function validateHourFormat(value?: string): boolean {
  if (!value) {
    return false;
  }

  const [hours, minutes] = value.split(':');

  if (!hours || !minutes || hours.length < 2 || minutes.length < 2) {
    return false;
  }

  return Number(hours) < 24 && Number(minutes) < 60;
}

export const scheduleDataSchema = Yup.object().shape<ServiceScheduleDataFormShape>({
  days: Yup.array().required('Selecione um ou mais dias'),
  endAt: Yup.string()
    .required('Digite o horário')
    .test('endAt', 'Digite um horário válido', (val) => validateHourFormat(val)),
  startAt: Yup.string()
    .required('Digite o horário')
    .test('startAt', 'Digite um horário válido', (val) => validateHourFormat(val)),
});
